@use '@lib/assets/styles/main.scss' as *;

%circle {
  display: block;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  border: 1px solid $gray0;
}

.usersAvatarsPreviewRow {
  display: flex;
  align-items: center;
  cursor: pointer;
  .avatar {
    @extend %circle;
    img, svg {
      display: block;
      border-radius: inherit;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid $gray100;
    }
  }
  & > * + * {
    margin-left: -8px;
    width: 32px;
  }
  .counter {
    @extend %circle;
    color: $gray500;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $gray10;
    cursor: pointer;
  }
}
